module.exports = __webpack_public_path__ + "static/media/products.52a96f51.svg";